import { Button, Input, Label, TOUCH } from "@nymbl/nos2-rules";
import { useState } from "react";
import { cn } from "@/lib/utils";

interface CommentNeededProps {
  id: string;
  /** "Wed needs a comment to save". */
  label: string;
  saving: boolean;
  onSave: (comment: string) => void;
}

export function CommentNeeded({ id, label, saving, onSave }: CommentNeededProps) {
  const [draft, setDraft] = useState("");
  const comment = draft.trim();
  return (
    <div className="mt-2 max-w-md space-y-1 rounded-md bg-warning-bg p-2">
      <Label htmlFor={id} className="text-xs font-semibold text-warning">
        {label}
      </Label>
      <div className="flex gap-2">
        <Input
          id={id}
          value={draft}
          maxLength={4000}
          placeholder="What did you work on?"
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && comment && !saving) onSave(comment);
          }}
          // The warning surface stays light in dark mode, so the box brings its own background.
          className={cn(TOUCH, "bg-background text-foreground dark:bg-background")}
        />
        <Button
          type="button"
          size="sm"
          className={TOUCH}
          disabled={!comment || saving}
          onClick={() => onSave(comment)}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
